import { round, roundedTotal } from '../math';

export const calculateProductRestockingFee = (
    productTotalCredited: number,
    applied: boolean,
    percentage: number
): number => {
    if (!applied) return 0;
    const validPercentage = Math.min(100, Math.max(0, percentage));
    return round(productTotalCredited * validPercentage / 100);
};

export const calculateTotalRestockingFee = (restockingFees: number[]): number =>
    round(restockingFees.reduce((total, fee) => total + fee, 0));

export const calculateProductRefundAmount = (
    productTotalCredited: number,
    restockingFee: number
): number => round(productTotalCredited - Math.max(0, restockingFee));

export const calculateCustomerCredit = (
    productReturnValue: number,
    restockingFee: number,
    freightAmount: number
): number => round(
    productReturnValue - Math.max(0, restockingFee) - Math.max(0, freightAmount)
);

export const calculateCustomerCreditIncludingGst = (customerCreditExGst: number): number =>
    roundedTotal(customerCreditExGst);

export const customerCreditExceedsPaid = (
    customerCreditExGst: number,
    amountPaid: number
): boolean => calculateCustomerCreditIncludingGst(customerCreditExGst) > Math.max(0, amountPaid);
